export default __webpack_public_path__ + "images/3228c7f1f7696e7aeccfa37c0a8eb57f-relationships.svg";